import { FunctionComponent } from "react";
import NAV from "../components/NAV";

const Lesson46: FunctionComponent = () => {
  return (
    <div className="relative [background:linear-gradient(111.77deg,_rgba(0,_0,_0,_0),_#363636_78.54%),_#0d0d0d] w-full overflow-hidden flex flex-col items-center justify-center pt-[2.69rem] px-[5.63rem] pb-[7.63rem] box-border gap-[6.88rem] text-left text-[1.56rem] text-darkgray font-nunito">
      <NAV dimensionCode="/nav@2x.png" navIconFlexShrink="unset" />
      <div className="self-stretch flex flex-row items-center justify-between">
      <a className="cursor-pointer text-darkgray no-underline" href={"/lesson45"}>
        <div className="flex-1 rounded-32xl bg-gainsboro-200 box-border h-[3.5rem] flex flex-col items-center justify-center py-[0.69rem] px-[3rem] max-w-[12.5rem] border-[1px] border-solid border-gray-300">
          <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
            Back
          </b>
        </div>
        </a>
        <div className="self-stretch flex-1 flex flex-col items-center justify-center text-center text-[2.81rem] text-white">
          <b className="self-stretch relative leading-[100%]">Diet Creation</b>
        </div>
        <a className="cursor-pointer text-darkgray no-underline" href={"/lesson47"}>
        <div className="flex-1 rounded-32xl bg-gainsboro-200 box-border h-[3.5rem] flex flex-col items-center justify-center py-[0.69rem] px-[3rem] max-w-[12.5rem] border-[1px] border-solid border-gray-300">
          <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
            Next
          </b>
        </div>
        </a>
      </div>
      <div className="w-full flex flex-col items-center justify-center gap-[9.63rem] max-w-[125rem] text-justify text-white font-dm-sans">
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-gainsboro-100">
          <p className="m-0">
            Having covered the fundamental principles of body recomposition and
            the necessary tools for tracking progress, it's now time to develop
            a specific strategy to turn that goal into a reality.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            When designing a diet plan that aims to simultaneously lose fat and
            gain muscle, there are four key dietary principles to consider,
            listed in order of importance:
          </p>
          <p className="m-0">&nbsp;</p>
          <ul className="m-0 text-inherit pl-[1.32rem]">
            <li className="mb-[false]">
              <b className="font-dm-sans">{`CALORIE INTAKE: `}</b>
              <span>
                As previously mentioned, total calorie intake plays a primary
                role in driving changes in energy balance throughout the body.
                In this chapter, we will determine the appropriate calorie range
                for achieving your desired body composition based on your
                individual needs.
              </span>
            </li>
          </ul>
          <p className="m-0">&nbsp;</p>
          <ul className="m-0 text-inherit pl-[1.32rem]">
            <li className="mb-[false]">
              <b className="font-dm-sans">MACRONUTRIENT BREAKDOWN:</b>
              <span>
                {" "}
                Once calorie intake is established, it becomes crucial to
                understand the sources of those calories. We will establish the
                optimal ratios of protein, carbohydrates, and fats to maximize
                muscle growth, training performance, and overall body
                composition.
              </span>
            </li>
          </ul>
          <p className="m-0">&nbsp;</p>
          <ul className="m-0 text-inherit pl-[1.32rem]">
            <li className="mb-[false]">
              <b className="font-dm-sans">
                NUTRIENT TIMING AND MEAL DISTRIBUTION:
              </b>
              <span>
                {" "}
                After determining the ideal calorie and macronutrient intake, we
                need to organize our meals in a way that maximizes muscle
                gain/retention, supports performance, and aids in recovery.
              </span>
            </li>
          </ul>
          <p className="m-0">&nbsp;</p>
          <ul className="m-0 text-inherit pl-[1.32rem]">
            <li className="mb-[false]">
              <b className="font-dm-sans">FOOD SOURCES:</b>
              <span>
                {" "}
                The origin of our calories and macronutrients also matters when
                it comes to driving positive changes in body composition.We will
                discuss the significance of nutrient quality and its impact on
                achieving desired outcomes.
              </span>
            </li>
          </ul>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            Before diving into calorie intake, it's important to establish that
            these nutrition recommendations are primarily focused on optimizing
            body composition. While having a relatively lean body composition is
            closely associated with improved health outcomes, the hierarchy of
            priorities is structured as mentioned above, with the goal of
            optimizing body composition.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            However, it's essential to note that prioritizing body recomposition
            does not undermine the importance of eating for overall health. The
            two goals can and should be aligned with each other, even if their
            primary areas of emphasis slightly differ.
          </p>
        </div>
        <div className="self-stretch flex flex-row items-center justify-center text-left text-[1.88rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>
                <span>CALORIE INTAKE: HOW MANY CALORIES SHOULD I EAT?</span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  While some individuals may desire a straightforward and
                  precise calorie target, providing a generic calculation won't
                  suffice in the Ultimate Guide to Body Recomposition.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  The specific number of calories required for body
                  recomposition will primarily depend on three key individual
                  factors: your primary goal, your current body composition, and
                  your level of training experience. While Table 5A provides
                  specific examples of these three factors, it is crucial to
                  grasp their conceptual foundation first. Let's begin with the
                  primary goal.
                </span>
              </span>
            </p>
          </div>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.88rem]">
          <p className="m-0">
            <b>
              <span>1. Your Primary Goal :</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Undoubtedly, the aim of body recomposition is to simultaneously
                build muscle and lose fat, rather than choosing one over the
                other. However, we believe it is important to prioritize which
                goal holds greater significance for you, even if your ultimate
                desire is to achieve both outcomes.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                For instance, if you currently feel physically small and lacking
                in muscle mass, despite already being reasonably lean, you may
                prioritize building muscle over maintaining leanness.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Conversely, if you are presently overweight, even though you
                desire increased muscularity, it might be more crucial for you
                to focus on reducing body fat.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                There is also a scenario where you might fall under the category
                of being "skinny fat," meaning you possess low muscularity but a
                relatively high body fat percentage. Even in this case, it is
                essential to determine which aspect holds greater importance for
                you: appearing more muscular or becoming leaner.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                The reason we emphasize choosing a primary goal is that it
                influences the determination of your calorie intake. If your
                primary goal is fat loss, we recommend a moderate caloric
                deficit. On the other hand, if muscle building takes precedence,
                a moderate caloric surplus is more suitable. If both objectives
                carry equal weight, maintaining caloric balance (maintenance) is
                the suggested approach.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                While this decision may seem straightforward, it's worth noting
                that your current body composition and level of experience also
                play a role in establishing your calorie intake.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch flex flex-row items-center justify-center text-left">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0 text-[1.88rem]">
              <b>
                <span>2. Current Body Composition :</span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  Body composition is closely linked to your primary goal, and
                  individuals with different starting body fat percentages
                  should prioritize either fat loss or muscle building
                  accordingly. However, we recognize that determining your
                  primary goal may not always be straightforward.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  For instance, Joe, with a body fat percentage of 12%, may be
                  content with his level of leanness and prioritize building
                  muscle. Meanwhile, Jim, also at 12% body fat, may prefer to
                  become leaner. Despite having the same body fat percentage and
                  training age, Joe would opt for a slight caloric surplus,
                  whereas Jim would favor a slight caloric deficit.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  To define body composition, we'll categorize it into three
                  groups:
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <ul className="m-0 pl-[2.06rem]">
              <li className="mb-[0rem]">
                <span>
                  <span>Low Body Fat: 8-12% for men, 18-22% for women</span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>
                    Moderate Body Fat: 12-18% for men, 22-28% for women
                  </span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>High Body Fat: 18-20+% for men, 28-30%+ for women</span>
                </span>
              </li>
            </ul>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  As a general guideline, individuals with a lean physique will
                  likely achieve body recomposition best by entering a caloric
                  surplus. Trying to build muscle while in a caloric deficit or
                  maintenance may hinder progress. Conversely, those with a
                  higher body fat percentage should enter a caloric deficit to
                  promote fat loss, while progressive resistance training and
                  adequate protein intake support muscle growth.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  For individuals falling between these body fat categories,
                  closer adherence to maintenance calories is recommended. The
                  goal of losing fat and building muscle should be given roughly
                  equal importance. Here, you can refer back to your primary
                  goal determinant to decide whether to maintain true
                  maintenance, enter a slight surplus, or a slight deficit.
                </span>
              </span>
            </p>
          </div>
        </div>
        <div className="self-stretch flex flex-row items-center justify-center text-left">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0 text-[1.88rem]">
              <b>
                <span>3. Training Experience :</span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>{`Your training experience plays a significant role in determining how your body responds to caloric surpluses and deficits. `}</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>
                    Beginners have an advantage in gaining muscle quickly
                    without excessive fat gain, while advanced individuals are
                    more resistant to muscle gain and more prone to fat gain.
                  </span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>
                    Here's a breakdown of the three levels of training
                    experience:
                  </span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <b>&nbsp;</b>
                </span>
              </span>
            </p>
            <ul className="m-0 pl-[2.06rem]">
              <li className="mb-[0rem]">
                <span>
                  <span>
                    <b>BEGINNER:</b>
                    <span>
                      {" "}
                      Making consistent progress and noticeable visual changes
                      on a weekly and monthly basis (usually 0-2 years of
                      lifting).
                    </span>
                  </span>
                </span>
              </li>
            </ul>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <ul className="m-0 pl-[2.06rem]">
              <li className="mb-[0rem]">
                <span>
                  <span>
                    <b className="font-dm-sans">{`INTERMEDIATE: `}</b>
                    <span>
                      Progressing monthly with visible physique improvements
                      every few months (usually 2-5 years of lifting).
                    </span>
                  </span>
                </span>
              </li>
            </ul>
            <p className="m-0">
              <span>
                <span>
                  <b>&nbsp;</b>
                </span>
              </span>
            </p>
            <ul className="m-0 pl-[2.06rem]">
              <li className="mb-[0rem]">
                <span>
                  <span>
                    <b>ADVANCED:</b>
                    <span>
                      {" "}
                      Slow progress, taking months or years to see visual
                      changes and facing challenges in increasing lift loads
                      (usually 5+ years of serious lifting).
                    </span>
                  </span>
                </span>
              </li>
            </ul>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>
                    For example, a beginner with six months of lifting
                    experience aiming to build muscle can benefit from a larger
                    caloric surplus (e.g., 25%). In contrast, an advanced lifter
                    with five years of experience should opt for a smaller
                    surplus (e.g., 10%) to avoid excessive fat gain.
                  </span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>
                    While training age doesn't affect the size of a caloric
                    deficit directly, both beginners and veterans can achieve
                    fat loss equally effectively. Therefore, experience level
                    primarily influences the recommended caloric surplus rather
                    than the deficit.
                  </span>
                </span>
              </span>
            </p>
          </div>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0 text-[1.88rem]">
            <b>
              <span>4. Other Factors :</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  While the three main factors determine calorie intake for body
                  recomposition, there are additional considerations to keep in
                  mind.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b className="font-dm-sans">BIOFEEDBACK:</b>
                  <span>
                    {" "}
                    Pay attention to your body's signals, such as recovery and
                    hunger, during the recomp process. If your training
                    intensity or volume increases, it may be necessary to adjust
                    your calorie intake accordingly. Increased appetite can
                    indicate a need for more nutrients to support recovery.
                    While relying solely on appetite is not ideal, it can
                    provide valuable insights for adjusting calorie intake.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b className="font-dm-sans">THE DETRAINEE:</b>
                  <span>
                    {" "}
                    Body recomposition is common for individuals who previously
                    built muscle through resistance training but stopped for a
                    prolonged period. This phenomenon known as "muscle memory"
                    makes it easier to regain lost muscle compared to building
                    it from scratch. When we train and grow muscle fibers, we
                    also increase the number of control centers (myonuclei) in
                    the muscle. These myonuclei remain even when muscle size
                    decreases due to inactivity. Returning to training activates
                    these myonuclei, accelerating the production of new muscle
                    compared to starting from scratch.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  In summary, biofeedback and the phenomenon of muscle memory
                  can influence calorie intake during body recomposition. Paying
                  attention to your body's signals and understanding the
                  benefits of previous training experience can guide adjustments
                  in calorie intake for optimal results.
                </span>
              </span>
            </span>
          </p>
        </div>
        <img
          className="relative w-[96.75rem] h-[111rem] object-cover"
          alt=""
          src="/263@2x.png"
        />
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-gainsboro-100">
          <p className="m-0">
            Consider the analogy of a 900-pound polar bear losing weight during
            hibernation. When the bear resumes normal eating, it quickly regains
            lost body mass as both muscle and fat. Similarly, someone who
            trained for 10 years and then stopped for a year or two would likely
            lose their hard-earned muscle mass. However, due to persistent
            myonuclei, they can regain that lost muscle in a few months,
            compared to the 10 years it took to build it initially.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            For detrainees, starting at caloric maintenance is often a safe
            approach for losing fat and building muscle. They can experience
            significant recomposition progress within a relatively short
            timeframe, similar to beginners.
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.88rem]">
          <p className="m-0">
            <b>
              <span>Hitting Your Target</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                When providing nutritional recommendations for weight loss or
                weight gain, it's common to suggest adding or subtracting a
                specific number of calories from maintenance. However, these
                suggestions often oversimplify the complex nature of our
                metabolism and can lead to inaccurate predictions of weight loss
                or gain.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Similarly, guidelines based on a percentage of bodyweight gain
                per month may not account for individual variations in
                transformation rates. For example, a lean beginner following a
                recommended 1-1.5 percent weight gain per month might miss out
                on significant muscle gains if they were capable of gaining
                more.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                To address these limitations, we recommend setting calorie
                targets as percentage changes from maintenance calories. For
                instance, a lean male beginner may benefit from a caloric
                surplus of approximately 25 percent based on their starting body
                fat percentage.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                The table provided summarizes the information discussed above
                and serves as a framework for applying these recommendations.
                It's important to note that while comprehensive, the table may
                not cover all scenarios, and there may be exceptions that we
                will address further.
              </span>
            </span>
          </p>
        </div>
        <b className="self-stretch relative text-[1.88rem] tracking-[0.02em] leading-[2rem] text-gainsboro-100">
          *TABLE*
        </b>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-gainsboro-100">
          While the majority of individuals will find the above table
          applicable, there may be a few exceptional cases that fall outside its
          recommendations. However, statistically speaking, these exceptions are
          unlikely to apply to you.
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0 text-[1.88rem]">
            <b>
              <span>EXCEPTION 1: THE MUSCLE FREAK</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                In our previous recommendation, we advised lean beginners to
                enter a caloric surplus of approximately 25 percent. For the
                majority of beginners, this level of intake is sufficient to
                promote rapid muscle gain without excessive fat accumulation.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                However, there are individuals who possess a genetic advantage
                in gaining lean muscle at an accelerated rate. While precise
                genetic testing for muscular potential is still in its early
                stages, there are indicators that can provide an estimation. If
                most of the following characteristics apply to you, Exception 1
                MAY be applicable:
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  You have a larger frame, characterized by broad shoulders,
                  thick wrists, and ankles.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Your parents and/or multiple relatives have a muscular
                  physique.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>You demonstrate natural athletic abilities.</span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  You have observed rapid muscle development in your body.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  For men only: You have a high 2D:4D ratio, meaning your ring
                  finger is significantly longer than your index finger.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                If you believe that this exception aligns with your situation,
                you may consider increasing the recommended calorie surplus by
                an additional 5-10 percent, especially during the beginner to
                intermediate stages, to maximize your muscular potential.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.88rem]">
          <p className="m-0">
            <b>
              <span>EXCEPTION 2: THE OVERWEIGHT/OBESE</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                If your current body fat percentage exceeds 25 percent for men
                or 35 percent for women, it may be beneficial for you to aim for
                a larger caloric deficit than the recommendations mentioned
                earlier. For obese individuals, a caloric deficit ranging from
                20-30 percent can support more rapid fat loss while progressive
                weight training promotes muscle growth.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Irrespective of your primary goal, experience level, and current
                body composition, it is crucial to estimate your caloric
                maintenance. Understanding your daily calorie expenditure
                (caloric maintenance) is key to determining the appropriate
                calorie intake per day. Once you have determined your caloric
                maintenance, you can then establish your calorie goal based on
                the information provided in the table mentioned above.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] inline-block h-[12.13rem] shrink-0 text-[1.88rem]">
          <p className="m-0">
            <b>
              <span>Maintenance :</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Estimating your caloric maintenance is surprisingly simple. The
                objective is to determine the daily calorie intake required to
                maintain your current weight. Instead of viewing maintenance
                calories as a fixed number, they should be seen as a dynamic
                target that changes based on factors like body composition, NEAT
                levels, and metabolic factors. There are two methods we will
                present for estimating caloric maintenance: using a formula or a
                guess-and-check approach.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.88rem]">
          <p className="m-0">
            <b>
              <span>1. Formula-based estimation:</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                You might recall the Mifflin St. Jeor formula we discussed
                earlier for calculating BMR (Basal Metabolic Rate). Here it is
                again:
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                BMR (MALE) = 10 x WEIGHT (KG) + 6.25 x HEIGHT (CM) - 5 x AGE (Y)
                + 5 BMR (FEMALE) = 10 x WEIGHT (KG) + 6.25 x HEIGHT (CM) - 5 x
                AGE (Y) - 161 As a rough estimate of BMR, you can use the
                calculation: BMR (rough) = 10 x WEIGHT (lbs).
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                The above formulas provide an estimation of your basal metabolic
                rate, representing the calories burned per day at rest. To
                accurately determine maintenance calories, we also need to
                estimate the calories burned through daily activity, including
                exercise and NEAT (non-exercise activity thermogenesis). This
                can be done using the "activity multipliers" presented in Table
                5 below.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-gainsboro-100">
          <p className="m-0">
            To understand how to use the table provided, let's consider an
            example. Imagine a male who is 5'7" tall and weighs 150 pounds.
            Using the Mifflin St. Jeor formula, his BMR is approximately 1,639
            calories. He has a desk job but engages in regular dog walking.
            Referring to Table 5B, he decides to use the "lightly active"
            activity multiplier based on his lifestyle.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">{`To estimate his maintenance calories, he can use the following formula: `}</p>
          <p className="m-0">{`GUESSTIMATED MAINTENANCE = BMR (calculated using Mifflin St. Jeor) X ACTIVITY MULTIPLIER `}</p>
          <p className="m-0">GUESSTIMATED MAINTENANCE = 1,639 X 1.6</p>
          <p className="m-0">GUESSTIMATED MAINTENANCE = 2,622 calories.</p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0 text-[1.88rem]">
            <b>
              <span>2. Using A Guess And Check Method:</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  An alternative option to estimate your maintenance calories is
                  through a guess-and-check method. Here are the steps involved:
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 block pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <i className="font-bold">
                    Track your bodyweight and caloric intake daily for two
                    weeks.
                  </i>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <i className="font-bold">&nbsp;</i>
              </span>
            </span>
          </p>
          <ul className="m-0 block pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <i className="font-bold">
                    Calculate the average values for week one and week two.
                  </i>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <i className="font-bold">&nbsp;</i>
              </span>
            </span>
          </p>
          <ul className="m-0 block pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <i className="font-bold">
                    Determine the average weight change from week one to week
                    two.
                  </i>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <i className="font-bold">&nbsp;</i>
              </span>
            </span>
          </p>
          <ul className="m-0 block pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <i className="font-bold">
                    Use the weight change to determine your maintenance
                    calories: a. If you maintained weight from week one to week
                    two, your average caloric intake can be considered your
                    maintenance calories. b. If you lost weight from week one to
                    week two:
                  </i>
                </span>
              </span>
            </li>
          </ul>
          <ul className="m-0 block pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <i className="font-bold">
                    Assuming a 500 calorie deficit per day leads to one pound of
                    weight loss, calculate your maintenance by accounting for
                    the deficit. c. If you gained weight from week one to week
                    two:
                  </i>
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  <i className="font-bold">
                    Assuming a 500 calorie surplus per day leads to one pound of
                    weight gain, calculate your maintenance by accounting for
                    the surplus.
                  </i>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Using actual data from your body's response to food intake is
                  the advantage of the guess-and-check method. However, it takes
                  at least two weeks to obtain a reliable estimation of your
                  maintenance, which might be inconvenient if you're eager to
                  begin right away.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Regardless of the method chosen, once you have a good estimate
                  of your maintenance calories, you can refer to the table to
                  determine whether you should increase, decrease, or maintain
                  your caloric intake. Adjusting your calorie intake based on
                  the percentage guidelines provided in the table will set you
                  on the right path for your body recomposition journey.
                </span>
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0 text-[1.88rem]">
            <b>
              <span>{`Carb/Calorie Cycling & Refeeds :`}</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  In this course, we define a refeed as a 24-hour period with
                  increased caloric intake, usually through higher carbohydrate
                  intake. Refeeds are commonly used in diets for four reasons:
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <span>
                    Enhancing training performance, which can be hindered on
                    low-calorie or low-carb diets.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <span>
                    Providing a mental break from the monotony of a fat loss
                    diet.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <span>
                    Reversing negative hormonal adaptations associated with low
                    calories and low body fat percentages.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <span>Improving adherence to the diet.</span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  For achieving body recomposition, we recommend two approaches
                  based on your goals and circumstances:
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b>&nbsp;</b>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b>Linear Approach:</b>
                  <span>
                    {" "}
                    This approach involves eating the same calories and macros
                    daily without refeeds, high carb days, or calorie cycling.
                    It's suitable for individuals primarily focused on building
                    muscle in a caloric surplus. Varying carbohydrate intake
                    throughout the week is less important in a surplus, and
                    consistency in daily habits and meeting set targets is
                    emphasized.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b className="font-dm-sans">{`Logical Carb Cycling: `}</b>
                  <span>
                    This approach is recommended for those in a deficit or at
                    caloric maintenance seeking to optimize their diet. While
                    carb cycling has no significant metabolic advantage,
                    strategically partitioning energy intake on training and
                    rest days can prioritize nutrient timing around workouts.
                    For non-training days, reducing daily carb intake by
                    approximately 20 percent is suggested.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Both approaches offer benefits based on individual preferences
                  and circumstances. Sample meal plans for training and
                  non-training days are provided at the end of the course for
                  further guidance. It's important to monitor your physique,
                  strength levels, and scale weight changes to make adjustments
                  to your caloric intake over time and avoid plateaus.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  The goal of this course is to empower you to personalize your
                  own diet and make adjustments based on your body's response
                  and goals. In the next chapter, we will discuss strategies for
                  adjusting your caloric intake to ensure continuous progress as
                  your physique and goals evolve.
                </span>
              </span>
            </span>
          </p>
        </div>
        <a className="cursor-pointer text-darkgray no-underline" href={"/lesson47"}>
        <div className="rounded-32xl bg-gainsboro-200 box-border w-[25rem] flex flex-col items-center justify-center pt-[0.69rem] px-[3rem] pb-[1rem] max-w-[31.25rem] text-center text-[1.88rem] border-[1px] border-solid border-gray-300">
          <b className="self-stretch relative">Next Chapter</b>
        </div>
      </a>
      </div>
    </div>
  );
};

export default Lesson46;
